// To maintain the property values of obj1, set reverse to true
export const mergeObjects = (obj1: object, obj2: object, reverse: boolean = false) => {
  if (!obj1 || !obj2) {
    return {}
  }

  return reverse ? { ...obj2, ...obj1 } : { ...obj1, ...obj2 }
}
